import { jsx as _jsx } from "react/jsx-runtime";
import { SessionProvider, getSession } from 'next-auth/react';
import { useIsOnline } from '@ninja/web';
export const ShorySessionProvider = ({ children, session }) => {
    const isOnline = useIsOnline({
        onOnline: getSession,
    });
    return (_jsx(SessionProvider, { basePath: "/accounts/api/auth", session: session, refetchOnWindowFocus: isOnline, children: children }));
};
